import { render, staticRenderFns } from "./AdverseEventFormComponent.vue?vue&type=template&id=23f87527&scoped=true"
import script from "./AdverseEventFormComponent.vue?vue&type=script&lang=js"
export * from "./AdverseEventFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f87527",
  null
  
)

export default component.exports